export default __webpack_public_path__ + "static/media/Community.100dafa9.jpg";